import { register as registerSwiper } from 'swiper/element/bundle'
import * as basicLightbox from 'basiclightbox'

registerSwiper()

const productGalleryImageSwiper = document.querySelectorAll('swiper-container[data-custom-controls]')

// Pagination & Buttons are rendered separately, so we need to configure swiper accordingly and initialize it manually
productGalleryImageSwiper && productGalleryImageSwiper.forEach(swiperElement => {
    const customControls = swiperElement.querySelector('[data-swiper-controls]')
    const prevButton = customControls && customControls.querySelector('[data-swiper-button-prev]')
    const nextButton = customControls && customControls.querySelector('[data-swiper-button-next]')
    const pagination = customControls && customControls.querySelector('[data-swiper-pagination]')
    const zoomable = swiperElement.getAttribute('zoomable') !== 'false'
    const hasPointer = window.matchMedia('(hover: hover)').matches

    const swiperParams = {
        a11y: {
            id: swiperElement.id
        },
        navigation: {
            nextEl: customControls && nextButton,
            prevEl: customControls && prevButton,
        },
        pagination: {
            el: customControls && pagination,
            type: 'bullets'
        },
    }

    // merge params default and set on the element via attributes with custom ones
    Object.assign(swiperElement, swiperParams)

    swiperElement.initialize();

    const swiper = swiperElement.swiper;
    const slides = swiper.slides;

    const zoomRate = 3;

    slides.forEach(slide => {

        const image = slide.querySelector('img');
        const expandImageButton = slide.querySelector('[data-expand-image]');

        let isZoomedIn = false;
        const isZoomedInClass = 'zoomed-in';

        const handleMouseMove = (e) => {
            const slideRect = slide.getBoundingClientRect();
            const offsetX = e.clientX - slideRect.left;
            const offsetY = e.clientY - slideRect.top;

            const percentX = (offsetX / slideRect.width) * 100;
            const percentY = (offsetY / slideRect.height) * 100;

            // set the transform origin on the image
            image.style.transformOrigin = `${percentX}% ${percentY}%`;
        }

        const handleExpandImage = (e) => {
            e.preventDefault();
            e.stopPropagation();

            const imageSrc = e.currentTarget.dataset.expandImage ?? image.src;

            basicLightbox.create(`<img src="${imageSrc}" alt="${image?.alt ?? ''}" loading="lazy" />`).show();
        }

        expandImageButton && expandImageButton.addEventListener('click', handleExpandImage)

        if (zoomable && hasPointer) {
            slide.addEventListener('mouseenter', (e) => {
                slide.addEventListener('mousemove', handleMouseMove);
            })
            slide.addEventListener('mouseleave', (e) => {
                slide.addEventListener('mousemove', handleMouseMove);

                if (isZoomedIn) {
                    image.style.transform = `scale(1)`
                    isZoomedIn = false;
                    image.classList.remove(isZoomedInClass)
                }
            })
            slide.addEventListener('click', (e) => {
                if (isZoomedIn) {
                    image.style.transform = `scale(1)`
                    isZoomedIn = false;
                    image.classList.remove(isZoomedInClass)
                } else {
                    image.style.transform = `scale(${zoomRate})`
                    isZoomedIn = true;
                    image.classList.add(isZoomedInClass)
                }
            })
        }
    })

})